export const DEFAULT_WORKFLOW_NAME = "文生图";
export const DEFAULT_PROVIDER = "comfyui";

export function getWorkflowConfig(workflowName) {
  if (!workflowName) {
    return null;
  }
  return WORKFLOW_CONFIGS[workflowName] ?? null;
}

export const PROVIDER_CONFIGS = {
  comfyui: {
    label: "ComfyUI (本地)",
    workflows: ["文生图", "wan22"]
  },
  seedance: {
    label: "Seedance (火山方舟)",
    workflows: ["seedance-2-0", "seedance-2-0-fast"]
  },
  klingai: {
    label: "KlingAI (可灵)",
    workflows: ["klingai-omni", "klingai-omni-v3"]
  }
};

export const WORKFLOW_CONFIGS = {
  文生图: {
    label: "文生图（无参考图）",
    provider: "comfyui",
    allowedGenerateTypes: ["image"],
    supportsReferenceImages: false
  },
  wan22: {
    label: "wan2.2(首帧图)",
    provider: "comfyui",
    allowedGenerateTypes: ["video"],
    supportsReferenceImages: true,
    maxReferenceImages: 1,
    referenceImagesLabel: "首帧图",
    supportsVideoConfig: true,
    defaultVideoSeconds: 5,
    defaultVideoFps: 15
  },
  "seedance-2-0": {
    label: "seedance2.0",
    provider: "seedance",
    allowedGenerateTypes: ["video"],
    supportsReferenceImages: true,
    referenceImagesRequired: false,
    maxReferenceImages: 9,
    referenceImagesLabel: "参考图",
    supportsVideoConfig: true,
    /** 文档：2.0 的 frames/输出帧率用户侧不配置；界面上不展示帧率 */
    showVideoFps: false,
    /** 使用方舟 API 的 resolution，非像素宽高 */
    useArkOutputControls: true,
    outputResolutions: ["480p", "720p", "1080p"],
    outputRatios: ["16:9", "4:3", "1:1", "3:4", "9:16", "21:9", "adaptive"],
    defaultOutputResolution: "720p",
    defaultOutputRatio: "16:9",
    minVideoSeconds: 4,
    maxVideoSeconds: 15,
    allowAutoDuration: true,
    defaultVideoSeconds: 5,
    defaultVideoFps: 24
  },
  "seedance-2-0-fast": {
    label: "seedance2.0 fast",
    provider: "seedance",
    allowedGenerateTypes: ["video"],
    supportsReferenceImages: true,
    referenceImagesRequired: false,
    maxReferenceImages: 9,
    referenceImagesLabel: "参考图",
    supportsVideoConfig: true,
    showVideoFps: false,
    useArkOutputControls: true,
    outputResolutions: ["480p", "720p"],
    outputRatios: ["16:9", "4:3", "1:1", "3:4", "9:16", "21:9", "adaptive"],
    defaultOutputResolution: "720p",
    defaultOutputRatio: "16:9",
    minVideoSeconds: 4,
    maxVideoSeconds: 15,
    allowAutoDuration: true,
    defaultVideoSeconds: 5,
    defaultVideoFps: 24
  },
  "klingai-omni": {
    label: "可灵Omni (kling-video-o1)",
    provider: "klingai",
    allowedGenerateTypes: ["video"],
    supportsReferenceImages: true,
    maxReferenceImages: 7,
    referenceImagesLabel: "参考图",
    supportsVideoConfig: true,
    showVideoFps: false,
    useArkOutputControls: true,
    outputResolutions: ["720p"],
    outputRatios: ["16:9", "9:16", "1:1"],
    defaultOutputResolution: "720p",
    defaultOutputRatio: "16:9",
    minVideoSeconds: 3,
    maxVideoSeconds: 15,
    allowAutoDuration: false,
    defaultVideoSeconds: 5,
    defaultVideoFps: 24
  },
  "klingai-omni-v3": {
    label: "可灵Omni V3 (kling-v3-omni)",
    provider: "klingai",
    allowedGenerateTypes: ["video"],
    supportsReferenceImages: true,
    maxReferenceImages: 7,
    referenceImagesLabel: "参考图",
    supportsVideoConfig: true,
    showVideoFps: false,
    useArkOutputControls: true,
    outputResolutions: ["720p"],
    outputRatios: ["16:9", "9:16", "1:1"],
    defaultOutputResolution: "720p",
    defaultOutputRatio: "16:9",
    minVideoSeconds: 3,
    maxVideoSeconds: 15,
    allowAutoDuration: false,
    defaultVideoSeconds: 5,
    defaultVideoFps: 24
  }
};
